export default "__VITE_ASSET__h5$egRYq__"